import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue";
const _hoisted_1 = ["aria-labelledby", "data-testid"];
const _hoisted_2 = { class: "flex items-start justify-between gap-3" };
const _hoisted_3 = { class: "min-w-0" };
const _hoisted_4 = ["id"];
const _hoisted_5 = {
    key: 0,
    class: "mt-1 text-sm text-(--colors-text-body-subtle)"
};
import { useId } from "vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'DonationSettingsSection',
    props: {
        title: {},
        subtitle: {},
        testId: {}
    },
    setup(__props) {
        const headingId = useId();
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("section", {
                class: "flex flex-col gap-4 rounded-xl border border-(--colors-border-base-soft) bg-(--colors-background-white) p-5",
                "aria-labelledby": _unref(headingId),
                "data-testid": __props.testId
            }, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("h2", {
                            id: _unref(headingId),
                            class: "text-base font-semibold text-(--colors-text-heading)"
                        }, _toDisplayString(__props.title), 9 /* TEXT, PROPS */, _hoisted_4),
                        (__props.subtitle)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(__props.subtitle), 1 /* TEXT */))
                            : _createCommentVNode("v-if", true)
                    ]),
                    _renderSlot(_ctx.$slots, "badge")
                ]),
                _renderSlot(_ctx.$slots, "default")
            ], 8 /* PROPS */, _hoisted_1));
        };
    }
});
